module.exports = __webpack_public_path__ + "fonts/yubico_70x70.7f1bfceac388df5ddb85b4cc34219266.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/yubico_70x70.png
// module id = 787
// module chunks = 9